import React, { CSSProperties, FC } from 'react';
import { clss } from "../../utils/helpers/styleHelpers";
import { ProfilePhotoSizeE, UserRoleE } from "../../models/enums";
import { loading } from '../../assets/icons';
import { useAppSelector } from '../../store/hooks';
import { selectCurrentUser } from '../../store/selectors/authSelectors';
import DefaultLogo from '../BroadcasterCanvasLogo/DefaultLogo';

import styles from "./profilePhoto.module.scss";

type ProfilePhotoPropTypes = {
    size?: ProfilePhotoSizeE;
    className?: string;
    style?: CSSProperties;
    src?: any;
    role?: UserRoleE;
}

/**
 * Current user profile photo
 * */

const ProfilePhoto: FC<ProfilePhotoPropTypes> = (props) => {
    const {
        size = ProfilePhotoSizeE.MIDDLE,
        className = '',
        style = {},
        src,
        role
    } = props;
    const currentUser = useAppSelector(selectCurrentUser)

    return currentUser?.profilePhoto ? (
        <img
            style={style}
            className={clss([styles.profilePhoto, styles[size], className])}
            src={src || currentUser?.profilePhoto || loading}
            alt="user profile"
            title={currentUser?.userName}
        />
    ) : (
            <DefaultLogo size={size} role={role}/>
    );
};

export default ProfilePhoto;